var map = {
	"./chanping.png": "70f9",
	"./jishu.png": "55da",
	"./kefu.png": "d1a0",
	"./mendian.png": "06c7",
	"./sheji.png": "c008",
	"./shengchan.png": "2d34",
	"./wuliu.png": "b608",
	"./yunying.png": "ddfd",
	"./zhineng.png": "9fd9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fae3";